export default __webpack_public_path__ + "static/media/gymBoy.8fcd1669.jpg";